import React, { createContext, useContext, useEffect, useState } from 'react';
import { api } from '../lib/api';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(() => {
    try {
      const saved = localStorage.getItem('itanta.user');
      return saved ? JSON.parse(saved) : null;
    } catch (e) { return null; }
  });
  const [loading, setLoading] = useState(false);

  // On mount, if we have a token but no user, fetch /auth/me
  useEffect(() => {
    const token = localStorage.getItem('itanta.token');
    if (token && !user) {
      setLoading(true);
      api.get('/auth/me').then((r) => {
        setUser(r.data);
        localStorage.setItem('itanta.user', JSON.stringify(r.data));
      }).catch(() => {
        localStorage.removeItem('itanta.token');
        localStorage.removeItem('itanta.user');
      }).finally(() => setLoading(false));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const login = async (email, password) => {
    const r = await api.post('/auth/login', { email, password });
    localStorage.setItem('itanta.token', r.data.access_token);
    localStorage.setItem('itanta.user', JSON.stringify(r.data.user));
    setUser(r.data.user);
    return r.data.user;
  };

  const logout = () => {
    localStorage.removeItem('itanta.token');
    localStorage.removeItem('itanta.user');
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, loading, isAdmin: user?.role === 'admin' }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used within AuthProvider');
  return ctx;
};
